import axios from "axios";
import Config from "../consts/config";
import {
  getRefreshToken,
  setToken,
  setRefreshToken,
  setToken_type,
  deleteAllCookies,
} from "../utils/cookieAuth";


export function refreshAccessToken() {

  const _refreshToken = getRefreshToken();
  const payload = {
    refreshToken: _refreshToken,
  };
  return new Promise(function (resolve, reject) {
    axios
      .post(Config.API_URL + "auth/refresh-tokens", payload)
      .then((response) => {
        if (response?.status === 200) {
          setToken(response.data.access.token);
          setRefreshToken(response.data.refresh.token);
          setToken_type("Bearer");
        }
        resolve(response?.data?.tokens?.access?.token);
      })
      .catch((e) => {
        console.log(e, "Error refresh to api");
        // deleteAllCookies();
        // history.push("/sign-in");
        reject(e);
      });
  });
}
